import type { SVGProps } from 'react';

export const BjornIllustrationVer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='335'
    height='189'
    viewBox='0 0 335 189'
    fill='none'
    {...props}
    xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_9281_67296)'>
      <rect width='335' height='188' transform='translate(0 0.296875)' fill='#F4E0CC' />
      <g opacity='0.4' filter='url(#filter0_g_9281_67296)'>
        <ellipse cx='222' cy='177.5' rx='94' ry='104.5' fill='#D8601E' />
      </g>
      <path
        d='M153.143 114.014L182.178 103.291L247.558 99.0947L287.383 112.713C299.409 116.825 307.573 128.074 307.789 140.831L310 271.176C268.862 281.135 177.403 289.988 128 263.429L133.693 140.667C134.25 128.663 141.913 118.162 153.143 114.014Z'
        fill='#50B2C2'
      />
      <path
        d='M182.177 103.291L247.558 99.0947L220.745 196.294H211.562L182.177 103.291Z'
        fill='#F9EFE2'
      />
      <path
        d='M188.108 98.1724V87.2657L237.761 60.8223C238.365 73.8659 238.856 86.6485 239.504 93.4858L214.776 117.723L188.108 98.1724Z'
        fill='#EEC7B1'
      />
      <path
        d='M214.776 117.723L188.108 98.1724L182.177 103.152L204.032 128.144L214.776 117.723Z'
        fill='white'
      />
      <path
        d='M239.504 93.4858L214.776 117.723L226.805 127.037L247.558 99.0946L239.504 93.4858Z'
        fill='white'
      />
      <g filter='url(#filter1_f_9281_67296)'>
        <ellipse cx='206.42' cy='85.815' rx='16.5288' ry='5.34871' fill='#E9BC9B' />
      </g>
      <path
        d='M174.838 82.1041C181.292 88.487 207.875 91.0232 222.214 85.9072C231.58 82.5652 238.497 77.1491 238.286 72.443C237.887 63.6374 237.473 53.8263 236.945 45.0629C236.945 45.0629 243.537 44.5594 242.416 37.5843C241.295 30.6092 236.194 35.2097 236.194 35.2097C235.849 30.8689 235.607 28.1963 235.152 25.3133C232.212 6.66968 218.475 -2.92334 205.504 -2.92334C192.533 -2.92334 180.502 -0.000962973 171.509 15.3928C165.628 25.6554 167.748 75.0914 174.838 82.1041Z'
        fill='#EEC7B1'
      />
      <g filter='url(#filter2_f_9281_67296)'>
        <ellipse cx='185.387' cy='57.0424' rx='7.52977' ry='7.56197' fill='#E9BC9B' />
      </g>
      <g filter='url(#filter3_f_9281_67296)'>
        <ellipse cx='211.466' cy='53.7226' rx='7.52977' ry='7.56197' fill='#E9BC9B' />
      </g>
      <path
        d='M156.172 11.8059C155.505 17.8314 160.172 26.535 168.171 35.2386C170.305 30.9538 172.172 22.2948 172.838 18.501C173.505 22.518 185.505 23.857 218.837 4.44129C227.504 9.12785 234.171 17.8314 236.171 35.2386C238.171 30.3289 241.77 16.7602 240.17 1.76326C238.171 -16.983 223.504 -15.6439 218.837 -10.9574C217.282 -14.3049 212.571 -21 206.171 -21C198.171 -21 156.838 5.78031 156.172 11.8059Z'
        fill='#EFB100'
      />
      <path
        d='M195.454 57.8428C195.454 57.8428 193.146 64.2951 187.641 67.2376C182.136 70.1801 175.518 68.4986 175.518 68.4986C175.518 68.4986 177.825 62.0463 183.331 59.1037C188.836 56.1612 195.454 57.8428 195.454 57.8428Z'
        fill='#EFB100'
      />
      <path
        d='M195.51 57.826C195.51 57.826 199.687 63.5149 205.991 64.7884C212.294 66.0619 218.337 62.4378 218.337 62.4378C218.337 62.4378 214.16 56.7489 207.856 55.4754C201.553 54.2019 195.51 57.826 195.51 57.826Z'
        fill='#EFB100'
      />
      <ellipse
        cx='1.28561'
        cy='3.50422'
        rx='1.28561'
        ry='3.50422'
        transform='matrix(0.996162 -0.0875256 0.0867874 0.996227 181.142 39.3813)'
        fill='#014558'
      />
      <ellipse
        cx='1.28561'
        cy='3.50421'
        rx='1.28561'
        ry='3.50421'
        transform='matrix(0.996162 -0.0875256 0.0867875 0.996227 213.142 36.7036)'
        fill='#014558'
      />
      <ellipse opacity='0.45' cx='184.106' cy='47.5441' rx='9.3663' ry='3.87321' fill='#F9EFE2' />
      <path
        d='M189.441 54.3555C188.775 56.364 193.105 57.5958 195.86 57.5958L194.775 40.9653C193.219 44.7592 189.975 52.7487 189.441 54.3555Z'
        fill='#EEC6B0'
      />
      <path
        d='M195.86 57.5958C193.105 57.5958 188.775 56.364 189.441 54.3555C189.975 52.7487 193.219 44.7592 194.775 40.9653'
        stroke='#014558'
      />
      <path d='M192.141 47.499L195.378 47.499' stroke='#014558' />
      <ellipse opacity='0.45' cx='204.767' cy='47.5441' rx='9.3663' ry='3.87321' fill='#F9EFE2' />
      <path
        d='M175.538 31.2217C177.928 28.3536 184.034 26.9754 188.109 29.0834'
        stroke='#EFB100'
        strokeWidth='5'
      />
      <path
        d='M220.782 28.6397C218.392 25.7716 212.286 24.3934 208.212 26.5014'
        stroke='#EFB100'
        strokeWidth='5'
      />
      <path d='M213.949 70.5986C212.664 73.7341 209.725 74.9329 207.154 74.8407' stroke='#014558' />
      <mask
        id='mask0_9281_67296'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='182'
        y='99'
        width='66'
        height='105'>
        <path
          d='M182.177 103.291L247.558 99.0947L220.745 196.294L216.371 203.977L211.562 196.294L182.177 103.291Z'
          fill='#E9BC9B'
        />
      </mask>
      <g mask='url(#mask0_9281_67296)'>
        <path
          d='M205.777 126.484L214.776 117.723L224.693 125.47L215.878 135.89L230.111 203.026L215.878 214.922L201.737 203.026L215.878 135.89L205.777 126.484Z'
          fill='#D8601E'
        />
      </g>
      <path
        d='M273.958 108.132L247.558 99.0947L216.337 204.04L254.169 160.144L245.721 152.766H256.373L273.958 108.132Z'
        fill='#42A0AF'
      />
      <path
        d='M160.139 111.452L182.273 103.244L216.418 204.058L178.321 161.804L183.28 154.426L175.566 154.426L160.139 111.452Z'
        fill='#42A0AF'
      />
      <ellipse
        cx='18.5675'
        cy='3.85309'
        rx='18.5675'
        ry='3.85309'
        transform='matrix(0.930747 -0.365664 0.362966 0.931802 242.352 178.562)'
        fill='#014558'
      />
      <path
        d='M254.761 121.163L278.201 181.777L249.791 193.541L248.853 175.443C245.168 176.614 237.046 177.38 233.444 176.516C230.543 174.085 224.144 157.331 228.669 146.821C233.054 143.598 244.188 141.293 251.026 143.172C251.026 143.172 248.974 132.326 249.962 129.124C250.797 125.797 252.254 122.789 254.761 121.163Z'
        fill='#EEC6B0'
      />
      <line
        y1='-0.5'
        x2='12.3215'
        y2='-0.5'
        transform='matrix(0.983735 -0.179626 0.178148 0.984004 227.016 155.121)'
        stroke='#014558'
      />
      <line
        y1='-0.5'
        x2='12.3215'
        y2='-0.5'
        transform='matrix(0.983735 -0.179626 0.178148 0.984004 228.091 163.464)'
        stroke='#014558'
      />
      <line
        y1='-0.5'
        x2='12.3215'
        y2='-0.5'
        transform='matrix(0.983735 -0.179626 0.178148 0.984004 230.322 171.351)'
        stroke='#014558'
      />
      <path d='M248.844 175.452C250.676 174.775 251.596 174.283 253.068 173.239' stroke='#014558' />
      <path
        d='M298.457 218.199C289.877 231.759 273.676 259.542 273.297 260.251L243.979 182.48C245.56 183.949 253.475 182.471 262.43 178.953C271.338 175.453 278.125 171.172 278.363 169.005L298.457 218.199Z'
        fill='#50B2C2'
      />
      <ellipse cx='276.969' cy='180.942' rx='1.83652' ry='1.84438' fill='#006D86' />
      <path d='M278.142 168.516L293.104 205.147M243.954 182.053L266.134 241.205' stroke='#014558' />
      <path
        d='M284.191 183.329C284.963 185.312 277.852 189.959 268.307 193.709C258.763 197.458 250.4 198.891 249.627 196.908'
        stroke='#014558'
      />
      <path d='M165.282 276.34L163.445 182.276' stroke='#014558' />
      <path
        opacity='0.2'
        d='M168.22 35.0945C167.363 27.9321 166.42 12.6483 169.506 8.81201C173.362 4.01661 207.522 -11.5684 212.664 -9.53959C216.028 -8.21254 219.612 0.696723 219 4.47771C221.112 -1.23987 225.428 -7.97187 229.744 -6.58858C234.06 -5.2053 239.937 4.20106 236.263 34.8178'
        stroke='#965808'
      />
      <path
        opacity='0.2'
        d='M172.811 18.4029C182.912 19.4173 203.206 0.696835 209.266 -0.317576C214.115 -1.1291 217.714 2.47974 218.908 4.3856C222.03 -0.686463 225.244 -3.08416 228.642 -2.53085C232.039 -1.97753 236.998 2.63345 236.172 34.3568'
        stroke='#965808'
      />
    </g>
    <defs>
      <filter
        id='filter0_g_9281_67296'
        x='28'
        y='-27'
        width='388'
        height='409'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feTurbulence
          type='fractalNoise'
          baseFrequency='0.90909087657928467 0.90909087657928467'
          numOctaves='3'
          seed='1237'
        />
        <feDisplacementMap
          in='shape'
          scale='200'
          xChannelSelector='R'
          yChannelSelector='G'
          result='displacedImage'
          width='100%'
          height='100%'
        />
        <feMerge result='effect1_texture_9281_67296'>
          <feMergeNode in='displacedImage' />
        </feMerge>
      </filter>
      <filter
        id='filter1_f_9281_67296'
        x='181.891'
        y='72.4663'
        width='49.0576'
        height='26.6973'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='4' result='effect1_foregroundBlur_9281_67296' />
      </filter>
      <filter
        id='filter2_f_9281_67296'
        x='169.858'
        y='41.4805'
        width='31.0596'
        height='31.124'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='4' result='effect1_foregroundBlur_9281_67296' />
      </filter>
      <filter
        id='filter3_f_9281_67296'
        x='195.937'
        y='38.1606'
        width='31.0596'
        height='31.124'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'>
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='4' result='effect1_foregroundBlur_9281_67296' />
      </filter>
      <clipPath id='clip0_9281_67296'>
        <rect width='335' height='188' fill='white' transform='translate(0 0.296875)' />
      </clipPath>
    </defs>
  </svg>
);
